// autoTranslate.js — Automatic ES → EN/PT/FR translation for hardcoded strings.
// Used as a safety-net by useLanguage().t() when a translation key is missing
// but the fallback is in Spanish and the user's language is not Spanish.
//
// Keep entries short, exact matches. Case-sensitive. Order doesn't matter.

const ES_TO_EN = {
  // ===== Common UI =====
  'Sí': 'Yes', 'No': 'No', 'Aceptar': 'Accept', 'Cancelar': 'Cancel',
  'Guardar': 'Save', 'Eliminar': 'Delete', 'Editar': 'Edit', 'Crear': 'Create',
  'Cerrar': 'Close', 'Buscar': 'Search', 'Filtrar': 'Filter', 'Todos': 'All',
  'Todas': 'All', 'Ninguno': 'None', 'Ver': 'View', 'Más': 'More',
  'Detalles': 'Details', 'Agregar': 'Add', 'Nuevo': 'New', 'Nueva': 'New',
  'Activo': 'Active', 'Inactivo': 'Inactive', 'Pendiente': 'Pending',
  'Pendientes': 'Pending', 'Aprobado': 'Approved', 'Aprobadas': 'Approved',
  'Cancelado': 'Cancelled', 'Canceladas': 'Cancelled', 'Recibido': 'Received',
  'Recibidas': 'Received', 'Completado': 'Completed', 'En progreso': 'In progress',
  'Total': 'Total', 'Subtotal': 'Subtotal', 'Cantidad': 'Quantity',
  'Precio': 'Price', 'Descuento': 'Discount', 'Impuesto': 'Tax',
  'Fecha': 'Date', 'Hora': 'Time', 'Estado': 'Status', 'Acciones': 'Actions',
  'Notas': 'Notes', 'Descripción': 'Description', 'Nombre': 'Name',
  'Apellido': 'Last name', 'Correo': 'Email', 'Email': 'Email',
  'Teléfono': 'Phone', 'Celular': 'Phone', 'Dirección': 'Address',
  'Ciudad': 'City', 'País': 'Country', 'Empresa': 'Company',
  'Cargo': 'Position', 'Departamento': 'Department', 'Imprimir': 'Print',
  'Exportar': 'Export', 'Importar': 'Import', 'Compartir': 'Share',
  'Descargar': 'Download', 'Subir': 'Upload', 'Refrescar': 'Refresh',
  'Actualizar': 'Update', 'Confirmar': 'Confirm', 'Continuar': 'Continue',
  'Atrás': 'Back', 'Siguiente': 'Next', 'Anterior': 'Previous',

  // ===== Negocio / Finanzas =====
  'Ventas': 'Sales', 'Ingresos': 'Income', 'Gastos': 'Expenses',
  'Ganancia': 'Profit', 'Pérdida': 'Loss', 'Balance': 'Balance',
  'Saldo': 'Balance', 'Caja': 'Cash', 'Banco': 'Bank',
  'Efectivo': 'Cash', 'Tarjeta': 'Card', 'Transferencia': 'Transfer',
  'Pago': 'Payment', 'Pagos': 'Payments', 'Cobros': 'Receivables',
  'Deudas': 'Debts', 'Facturas': 'Invoices', 'Factura': 'Invoice',
  'Recibo': 'Receipt', 'Recibos': 'Receipts', 'Compras': 'Purchases',
  'Compra': 'Purchase', 'Inventario': 'Inventory', 'Producto': 'Product',
  'Productos': 'Products', 'Servicio': 'Service', 'Servicios': 'Services',
  'Stock': 'Stock', 'Categoría': 'Category', 'Categorías': 'Categories',
  'Marca': 'Brand', 'Código': 'Code', 'SKU': 'SKU',
  'Cliente': 'Client', 'Clientes': 'Clients', 'Prospecto': 'Prospect',
  'Prospectos': 'Prospects', 'Empleado': 'Employee', 'Empleados': 'Employees',
  'Proveedor': 'Supplier', 'Proveedores': 'Suppliers',
  'Comprador': 'Buyer', 'Compradores': 'Buyers',
  'Vendedor': 'Seller', 'Vendedores': 'Sellers',
  'Hoy': 'Today', 'Ayer': 'Yesterday', 'Mañana': 'Tomorrow',
  'Esta Semana': 'This Week', 'Este Mes': 'This Month', 'Este Año': 'This Year',
  'Semana': 'Week', 'Mes': 'Month', 'Año': 'Year', 'Día': 'Day',
  'Cumpleaños': 'Birthday', 'Cumpleaños Hoy': 'Birthdays Today',
  'Total Clientes': 'Total Clients', 'Total Productos': 'Total Products',
  'Total Mes': 'Monthly Total', 'Total Año': 'Yearly Total',
  'Total Anual': 'Annual Total', 'Gasto Mes': 'Monthly Spend',
  'Órdenes': 'Orders', 'Orden': 'Order', 'Nueva Orden': 'New Order',
  'Nuevo Proveedor': 'New Supplier', 'Nueva Factura': 'New Invoice',
  'Agregar Factura': 'Add Invoice', 'Nuevo Cliente': 'New Client',
  'Nueva Cita': 'New Appointment', 'Nueva Tarea': 'New Task',
  'Nueva Compra': 'New Purchase', 'Nuevo Empleado': 'New Employee',

  // ===== Citas / Tareas =====
  'Cita': 'Appointment', 'Citas': 'Appointments', 'Tarea': 'Task',
  'Tareas': 'Tasks', 'Recordatorio': 'Reminder', 'Notificación': 'Notification',
  'Prioridad': 'Priority', 'Alta': 'High', 'Media': 'Medium', 'Baja': 'Low',
  'Vence': 'Due', 'Vencido': 'Overdue', 'Programado': 'Scheduled',
  'En Proceso': 'In Progress', 'Terminado': 'Done', 'Pausado': 'Paused',

  // ===== Real Estate =====
  'Propiedad': 'Property', 'Propiedades': 'Properties', 'Inmueble': 'Property',
  'Inmuebles': 'Properties', 'Renta': 'Rent', 'Alquiler': 'Rent',
  'Venta': 'Sale', 'Habitaciones': 'Bedrooms', 'Baños': 'Bathrooms',
  'Área': 'Area', 'Casa': 'House', 'Apartamento': 'Apartment',
  'Local': 'Shop', 'Oficina': 'Office', 'Terreno': 'Land', 'Bodega': 'Warehouse',

  // ===== Empty / Status messages =====
  'No hay datos': 'No data', 'No hay resultados': 'No results',
  'No hay clientes': 'No clients', 'No hay prospectos': 'No prospects',
  'No hay productos': 'No products', 'No hay facturas': 'No invoices',
  'No hay tareas': 'No tasks', 'No hay citas': 'No appointments',
  'No hay empleados': 'No employees', 'No hay cuentas': 'No accounts',
  'No hay órdenes': 'No orders', 'No hay registros': 'No records',
  'Cargando...': 'Loading...', 'Cargando': 'Loading',
  'Procesando...': 'Processing...', 'Guardando...': 'Saving...',
  'Generando...': 'Generating...', 'Buscando...': 'Searching...',
  'Sin resultados': 'No results', 'Sin datos': 'No data',
  'Próximamente': 'Coming soon',

  // ===== Plurals/short common phrases =====
  'Cliente VIP': 'VIP Client', 'Cliente Frecuente': 'Frequent Client',
  'Cliente Nuevo': 'New Client', 'Cliente Inactivo': 'Inactive Client',
  'Reloj Checador': 'Time Clock', 'Pay Stubs': 'Pay Stubs',
  'Asistencia': 'Attendance', 'Nómina': 'Payroll',
  'Categorías': 'Categories', 'Estadísticas': 'Stats',
  'Configuración': 'Settings', 'Ajustes': 'Settings', 'Perfil': 'Profile',
  'Cerrar Sesión': 'Sign Out', 'Iniciar Sesión': 'Sign In',
  'Crear Cuenta': 'Sign Up', 'Mi Cuenta': 'My Account',

  // ===== Common verbs / actions =====
  'Reservar': 'Book', 'Solicitar': 'Request', 'Enviar': 'Send',
  'Recibir': 'Receive', 'Aprobar': 'Approve', 'Rechazar': 'Reject',
  'Pagar': 'Pay', 'Cobrar': 'Charge', 'Vender': 'Sell',
  'Comprar': 'Buy', 'Asignar': 'Assign', 'Marcar': 'Mark',

  // ===== Common nouns short =====
  'Hora de entrada': 'Check-in time', 'Hora de salida': 'Check-out time',
  'Entrada': 'Check In', 'Salida': 'Check Out',
  'Recibida': 'Received',

  // ===== Longer phrases / subtitles =====
  'Administra productos, stock y códigos de barras': 'Manage products, stock and barcodes',
  'Costo total empleador': 'Total employer cost',
  '¡Bienvenido!': 'Welcome!',
  'Tu sistema ERP todo-en-uno.': 'Your all-in-one ERP system.',
  'Tu sistema ERP todo-en-uno': 'Your all-in-one ERP system',
  'Cálculo estimado basado en tarifas': 'Estimated calculation based on rates',
  'Escanear': 'Scan',
  'Conteo': 'Count',
  'Etiquetas': 'Labels',
  'A: Alto (80%)': 'A: High (80%)',
  'B: Medio (15%)': 'B: Medium (15%)',
  'C: Bajo (5%)': 'C: Low (5%)',
  'Alto': 'High', 'Medio': 'Medium', 'Bajo': 'Low',
  'Sin datos para mostrar': 'No data to show',
  'Sin movimientos': 'No movements',
  'Selecciona': 'Select', 'Selecciona una opción': 'Select an option',
  'Categoría:': 'Category:', 'Estado:': 'Status:', 'Fecha:': 'Date:',
  'Total:': 'Total:', 'Subtotal:': 'Subtotal:',
  'Hace': 'Ago', 'minutos': 'minutes', 'minuto': 'minute',
  'horas': 'hours', 'hora': 'hour', 'segundos': 'seconds',
  'días': 'days', 'día': 'day',
  'No hay deudores registrados': 'No debtors registered',
  'No hay ordenes de compra': 'No purchase orders',
  'No hay registros de nómina': 'No payroll records',
  'No hay registros de asistencia este mes': 'No attendance records this month',
  'No hay pay stubs generados': 'No pay stubs generated',
  'No tienes presupuestos configurados': 'You have no budgets configured',
  'No tienes estimados creados': 'You have no estimates created',
  'No hay empresas registradas': 'No companies registered',
  'No hay tareas creadas': 'No tasks created',

  // ===== Tabs / Stats labels =====
  'Mis Notas': 'My Notes', 'Mis Tareas': 'My Tasks',
  'Mi Cuenta': 'My Account', 'Mi Negocio': 'My Business',
  'Reportes Financieros': 'Financial Reports', 'Reportes': 'Reports',
  'Flujo de Caja': 'Cash Flow', 'Metas de Ventas': 'Sales Goals',
  'Rentabilidad': 'Profitability', 'Proyecciones': 'Projections',
  'Historial de Ventas': 'Sales History', 'Comparativo': 'Comparison',
  'Análisis de Gastos': 'Expense Analysis', 'Análisis': 'Analysis',
  'Herramientas Financieras': 'Financial Tools',
  'Cerrar Caja': 'Close Register', 'Abrir Caja': 'Open Register',
  'Iniciar Venta': 'Start Sale', 'Pagar Ahora': 'Pay Now',
  'Marcar Pagado': 'Mark as Paid', 'Marcar Recibido': 'Mark as Received',

  // ===== Statuses common =====
  'Activos': 'Active', 'Inactivos': 'Inactive',
  'Por Cobrar': 'Receivables', 'Por Pagar': 'Payables',
  'Pagado': 'Paid', 'Pagados': 'Paid',
  'Sin Pagar': 'Unpaid', 'Vencidas': 'Overdue', 'Adelantado': 'Advanced',
  'Hoy': 'Today', 'Mes Actual': 'Current Month', 'Año Actual': 'Current Year',

  // ===== Real Estate =====
  'Para Renta': 'For Rent', 'Para Venta': 'For Sale',
  'Disponible': 'Available', 'No Disponible': 'Unavailable',
  'Vendida': 'Sold', 'Rentada': 'Rented',
  'Bañera': 'Bath', 'Habitación': 'Bedroom',

  // ===== Generic small =====
  'Sin imagen': 'No image', 'Sin foto': 'No photo',
  'Foto': 'Photo', 'Imagen': 'Image', 'Video': 'Video',
  'Archivo': 'File', 'Archivos': 'Files',
  'Documento': 'Document', 'Documentos': 'Documents',
  'Mensaje': 'Message', 'Mensajes': 'Messages',
  'Notificaciones': 'Notifications', 'Alerta': 'Alert', 'Alertas': 'Alerts',
  'Tipo': 'Type', 'Método': 'Method', 'Forma de pago': 'Payment method',
  'Cuenta': 'Account', 'Cuentas': 'Accounts',
  'Resumen': 'Summary', 'Detalle': 'Detail',
  'Ver más': 'See more', 'Ver menos': 'See less',
  'Ver todo': 'View all', 'Ver todos': 'View all',

  // ===== Specific phrases found in the app =====
  '+ Agregar Vehículo': '+ Add Vehicle',
  '+ Crear tu primer presupuesto': '+ Create your first budget',
  '+ Crear tu primera tarea': '+ Create your first task',
  '+ Gasto': '+ Expense',
  '+ Ingreso': '+ Income',
  'Agregar Cuenta': 'Add Account',
  'Caja / POS': 'Cash / POS',
  'Comparativo Ingresos vs Gastos': 'Income vs Expenses Comparison',
  'Cuentas por Pagar': 'Accounts Payable',
  'Cuentas por Cobrar': 'Accounts Receivable',
  'ES · España (Agencia Tributaria)': 'ES · Spain (Tax Agency)',
  'España': 'Spain', 'Estados Unidos': 'United States', 'México': 'Mexico',
  'Colombia': 'Colombia', 'Argentina': 'Argentina', 'Brasil': 'Brazil',
  'Notas de voz y dictados guardados por Briefy. Tu cuaderno inteligente.':
    'Voice notes and dictations saved by Briefy. Your smart notebook.',
  'Nueva nota': 'New note',
  'Órdenes de Compra': 'Purchase Orders',
  'Ordenes de Compra': 'Purchase Orders',
  'Otros Ingresos': 'Other Income',
  'Otros Gastos': 'Other Expenses',
  'Presupuesto Total': 'Total Budget',
  'Presupuesto': 'Budget',
  'Presupuestos por Categoría': 'Budgets by Category',
  'Presupuestos': 'Budgets',
  'Reporte': 'Report',
  'Resumen del Mes': 'Monthly Summary',
  'Resumen del Día': 'Daily Summary',
  'Resumen del Año': 'Yearly Summary',
  'Todos los estados': 'All statuses',
  'Todas las categorías': 'All categories',
  'Total Gastos': 'Total Expenses',
  'Total Ingresos': 'Total Income',
  'Vencen Hoy': 'Due Today',
  'Vencen esta Semana': 'Due This Week',
  'Vencidos': 'Overdue',
  'Ventas POS': 'POS Sales',
  '📅 Hoy': '📅 Today',
  '📅 Ayer': '📅 Yesterday',
  '📅 Esta Semana': '📅 This Week',
  '📅 Este Mes': '📅 This Month',

  // ===== More common UI labels =====
  'Sin tareas pendientes': 'No pending tasks',
  'Sin citas próximas': 'No upcoming appointments',
  'Sin facturas pendientes': 'No pending invoices',
  'Sin productos': 'No products',
  'Próximos': 'Upcoming', 'Próxima': 'Next', 'Anteriores': 'Previous',
  'Página': 'Page', 'de': 'of', 'a': 'to',
  'Aplicar': 'Apply', 'Limpiar': 'Clear', 'Restablecer': 'Reset',
  'Acciones': 'Actions', 'Acción': 'Action',
  'Bienvenido': 'Welcome', 'Bienvenida': 'Welcome',
  'Buenos días': 'Good morning', 'Buenas tardes': 'Good afternoon', 'Buenas noches': 'Good evening',
  '¡Hola!': 'Hi!', 'Hola': 'Hi',
  'Adiós': 'Goodbye', 'Hasta luego': 'See you later',
  'Cierre del Día': 'Daily Close', 'Cierre Diario': 'Daily Close',
  'Apertura': 'Opening', 'Cierre': 'Closing',
  'Métodos de Pago': 'Payment Methods',
  'Ver historial': 'View history',
  'Ver detalles': 'View details',
  'Marcar como pagado': 'Mark as paid',
  'Marcar como recibido': 'Mark as received',
  'Pagar ahora': 'Pay now',
  'Recordar': 'Remind',
  'Notificar': 'Notify',
  'Hacer copia': 'Make a copy',
  'Duplicar': 'Duplicate',
  'Compartir por WhatsApp': 'Share via WhatsApp',
  'Compartir por Email': 'Share via Email',
  'Enviar por WhatsApp': 'Send via WhatsApp',
  'Enviar por Email': 'Send via Email',
  'Enviar recordatorio': 'Send reminder',
  'Vehículo': 'Vehicle', 'Vehículos': 'Vehicles',
  'Mantenimiento': 'Maintenance', 'Combustible': 'Fuel',
  'Kilómetros': 'Kilometers', 'Millas': 'Miles',
  'Modelo': 'Model', 'Placa': 'License Plate',
  'Año del vehículo': 'Vehicle year',
};

const ES_TO_PT = {
  'Sí': 'Sim', 'No': 'Não', 'Aceptar': 'Aceitar', 'Cancelar': 'Cancelar',
  'Guardar': 'Salvar', 'Eliminar': 'Excluir', 'Editar': 'Editar', 'Crear': 'Criar',
  'Cerrar': 'Fechar', 'Buscar': 'Buscar', 'Filtrar': 'Filtrar', 'Todos': 'Todos',
  'Todas': 'Todas', 'Ver': 'Ver', 'Más': 'Mais', 'Detalles': 'Detalhes',
  'Agregar': 'Adicionar', 'Nuevo': 'Novo', 'Nueva': 'Nova',
  'Activo': 'Ativo', 'Inactivo': 'Inativo', 'Pendiente': 'Pendente',
  'Pendientes': 'Pendentes', 'Aprobado': 'Aprovado', 'Aprobadas': 'Aprovadas',
  'Cancelado': 'Cancelado', 'Canceladas': 'Canceladas',
  'Recibido': 'Recebido', 'Recibidas': 'Recebidas', 'Completado': 'Concluído',
  'En progreso': 'Em andamento', 'Total': 'Total', 'Cantidad': 'Quantidade',
  'Precio': 'Preço', 'Descuento': 'Desconto', 'Fecha': 'Data', 'Hora': 'Hora',
  'Estado': 'Status', 'Notas': 'Notas', 'Descripción': 'Descrição',
  'Nombre': 'Nome', 'Apellido': 'Sobrenome', 'Correo': 'E-mail', 'Email': 'E-mail',
  'Teléfono': 'Telefone', 'Celular': 'Celular', 'Dirección': 'Endereço',
  'Ciudad': 'Cidade', 'País': 'País', 'Empresa': 'Empresa',
  'Cargo': 'Cargo', 'Departamento': 'Departamento', 'Imprimir': 'Imprimir',
  'Exportar': 'Exportar', 'Importar': 'Importar', 'Compartir': 'Compartilhar',
  'Descargar': 'Baixar', 'Subir': 'Enviar', 'Refrescar': 'Atualizar',
  'Confirmar': 'Confirmar', 'Continuar': 'Continuar',
  'Atrás': 'Voltar', 'Siguiente': 'Próximo', 'Anterior': 'Anterior',
  'Ventas': 'Vendas', 'Ingresos': 'Receitas', 'Gastos': 'Despesas',
  'Ganancia': 'Lucro', 'Pérdida': 'Perda', 'Balance': 'Saldo', 'Saldo': 'Saldo',
  'Caja': 'Caixa', 'Banco': 'Banco', 'Efectivo': 'Dinheiro', 'Tarjeta': 'Cartão',
  'Transferencia': 'Transferência', 'Pago': 'Pagamento', 'Pagos': 'Pagamentos',
  'Deudas': 'Dívidas', 'Facturas': 'Faturas', 'Factura': 'Fatura',
  'Recibo': 'Recibo', 'Recibos': 'Recibos', 'Compras': 'Compras',
  'Compra': 'Compra', 'Inventario': 'Inventário', 'Producto': 'Produto',
  'Productos': 'Produtos', 'Servicio': 'Serviço', 'Servicios': 'Serviços',
  'Stock': 'Estoque', 'Categoría': 'Categoria', 'Categorías': 'Categorias',
  'Marca': 'Marca', 'Código': 'Código', 'Cliente': 'Cliente',
  'Clientes': 'Clientes', 'Prospecto': 'Prospecto', 'Prospectos': 'Prospectos',
  'Empleado': 'Funcionário', 'Empleados': 'Funcionários',
  'Proveedor': 'Fornecedor', 'Proveedores': 'Fornecedores',
  'Comprador': 'Comprador', 'Compradores': 'Compradores',
  'Vendedor': 'Vendedor', 'Vendedores': 'Vendedores',
  'Hoy': 'Hoje', 'Ayer': 'Ontem', 'Mañana': 'Amanhã',
  'Esta Semana': 'Esta Semana', 'Este Mes': 'Este Mês', 'Este Año': 'Este Ano',
  'Semana': 'Semana', 'Mes': 'Mês', 'Año': 'Ano', 'Día': 'Dia',
  'Cumpleaños': 'Aniversário', 'Cumpleaños Hoy': 'Aniversários Hoje',
  'Total Clientes': 'Total de Clientes', 'Total Productos': 'Total de Produtos',
  'Total Mes': 'Total do Mês', 'Total Año': 'Total do Ano',
  'Gasto Mes': 'Gasto do Mês', 'Órdenes': 'Pedidos', 'Orden': 'Pedido',
  'Nueva Orden': 'Novo Pedido', 'Nuevo Proveedor': 'Novo Fornecedor',
  'Nueva Factura': 'Nova Fatura', 'Agregar Factura': 'Adicionar Fatura',
  'Nuevo Cliente': 'Novo Cliente', 'Nueva Cita': 'Novo Compromisso',
  'Nueva Tarea': 'Nova Tarefa', 'Nueva Compra': 'Nova Compra',
  'Cita': 'Compromisso', 'Citas': 'Compromissos', 'Tarea': 'Tarefa',
  'Tareas': 'Tarefas', 'Recordatorio': 'Lembrete', 'Notificación': 'Notificação',
  'Prioridad': 'Prioridade', 'Alta': 'Alta', 'Media': 'Média', 'Baja': 'Baixa',
  'Vence': 'Vence', 'Vencido': 'Vencido', 'Programado': 'Agendado',
  'En Proceso': 'Em Andamento', 'Terminado': 'Concluído', 'Pausado': 'Pausado',
  'Propiedad': 'Imóvel', 'Propiedades': 'Imóveis', 'Inmueble': 'Imóvel',
  'Inmuebles': 'Imóveis', 'Renta': 'Aluguel', 'Alquiler': 'Aluguel',
  'Venta': 'Venda', 'Habitaciones': 'Quartos', 'Baños': 'Banheiros',
  'Área': 'Área', 'Casa': 'Casa', 'Apartamento': 'Apartamento',
  'Local': 'Loja', 'Oficina': 'Escritório', 'Terreno': 'Terreno',
  'No hay datos': 'Sem dados', 'No hay resultados': 'Sem resultados',
  'No hay clientes': 'Sem clientes', 'No hay productos': 'Sem produtos',
  'Cargando...': 'Carregando...', 'Cargando': 'Carregando',
  'Procesando...': 'Processando...', 'Guardando...': 'Salvando...',
  'Cliente VIP': 'Cliente VIP', 'Cliente Frecuente': 'Cliente Frequente',
  'Cliente Nuevo': 'Cliente Novo', 'Cliente Inactivo': 'Cliente Inativo',
  'Reloj Checador': 'Relógio de Ponto', 'Asistencia': 'Presença',
  'Nómina': 'Folha de Pagamento', 'Categorías': 'Categorias',
  'Estadísticas': 'Estatísticas', 'Configuración': 'Configurações',
  'Ajustes': 'Ajustes', 'Perfil': 'Perfil', 'Cerrar Sesión': 'Sair',
  'Iniciar Sesión': 'Entrar', 'Crear Cuenta': 'Cadastrar',
  'Reservar': 'Reservar', 'Solicitar': 'Solicitar', 'Enviar': 'Enviar',
  'Recibir': 'Receber', 'Aprobar': 'Aprovar', 'Rechazar': 'Rejeitar',
  'Pagar': 'Pagar', 'Cobrar': 'Cobrar', 'Vender': 'Vender', 'Comprar': 'Comprar',
  'Entrada': 'Entrada', 'Salida': 'Saída',
};

const ES_TO_FR = {
  'Sí': 'Oui', 'No': 'Non', 'Aceptar': 'Accepter', 'Cancelar': 'Annuler',
  'Guardar': 'Enregistrer', 'Eliminar': 'Supprimer', 'Editar': 'Modifier',
  'Crear': 'Créer', 'Cerrar': 'Fermer', 'Buscar': 'Rechercher',
  'Filtrar': 'Filtrer', 'Todos': 'Tous', 'Todas': 'Toutes', 'Ver': 'Voir',
  'Más': 'Plus', 'Detalles': 'Détails', 'Agregar': 'Ajouter',
  'Nuevo': 'Nouveau', 'Nueva': 'Nouvelle', 'Activo': 'Actif', 'Inactivo': 'Inactif',
  'Pendiente': 'En attente', 'Pendientes': 'En attente',
  'Aprobado': 'Approuvé', 'Aprobadas': 'Approuvées',
  'Cancelado': 'Annulé', 'Canceladas': 'Annulées',
  'Recibido': 'Reçu', 'Recibidas': 'Reçues', 'Completado': 'Terminé',
  'En progreso': 'En cours', 'Total': 'Total', 'Cantidad': 'Quantité',
  'Precio': 'Prix', 'Descuento': 'Remise', 'Fecha': 'Date', 'Hora': 'Heure',
  'Estado': 'État', 'Notas': 'Notes', 'Descripción': 'Description',
  'Nombre': 'Nom', 'Apellido': 'Nom de famille', 'Correo': 'E-mail',
  'Email': 'E-mail', 'Teléfono': 'Téléphone', 'Celular': 'Téléphone',
  'Dirección': 'Adresse', 'Ciudad': 'Ville', 'País': 'Pays',
  'Empresa': 'Entreprise', 'Cargo': 'Poste', 'Departamento': 'Département',
  'Imprimir': 'Imprimer', 'Exportar': 'Exporter', 'Importar': 'Importer',
  'Compartir': 'Partager', 'Descargar': 'Télécharger', 'Subir': 'Envoyer',
  'Refrescar': 'Actualiser', 'Confirmar': 'Confirmer', 'Continuar': 'Continuer',
  'Atrás': 'Retour', 'Siguiente': 'Suivant', 'Anterior': 'Précédent',
  'Ventas': 'Ventes', 'Ingresos': 'Revenus', 'Gastos': 'Dépenses',
  'Ganancia': 'Profit', 'Pérdida': 'Perte', 'Balance': 'Solde', 'Saldo': 'Solde',
  'Caja': 'Caisse', 'Banco': 'Banque', 'Efectivo': 'Espèces', 'Tarjeta': 'Carte',
  'Transferencia': 'Virement', 'Pago': 'Paiement', 'Pagos': 'Paiements',
  'Deudas': 'Dettes', 'Facturas': 'Factures', 'Factura': 'Facture',
  'Recibo': 'Reçu', 'Recibos': 'Reçus', 'Compras': 'Achats', 'Compra': 'Achat',
  'Inventario': 'Inventaire', 'Producto': 'Produit', 'Productos': 'Produits',
  'Servicio': 'Service', 'Servicios': 'Services', 'Stock': 'Stock',
  'Categoría': 'Catégorie', 'Categorías': 'Catégories',
  'Marca': 'Marque', 'Código': 'Code', 'Cliente': 'Client', 'Clientes': 'Clients',
  'Prospecto': 'Prospect', 'Prospectos': 'Prospects', 'Empleado': 'Employé',
  'Empleados': 'Employés', 'Proveedor': 'Fournisseur',
  'Proveedores': 'Fournisseurs', 'Comprador': 'Acheteur',
  'Compradores': 'Acheteurs', 'Vendedor': 'Vendeur', 'Vendedores': 'Vendeurs',
  'Hoy': "Aujourd'hui", 'Ayer': 'Hier', 'Mañana': 'Demain',
  'Esta Semana': 'Cette semaine', 'Este Mes': 'Ce mois', 'Este Año': 'Cette année',
  'Semana': 'Semaine', 'Mes': 'Mois', 'Año': 'Année', 'Día': 'Jour',
  'Cumpleaños': 'Anniversaire', 'Cumpleaños Hoy': "Anniversaires aujourd'hui",
  'Total Clientes': 'Total clients', 'Total Productos': 'Total produits',
  'Total Mes': 'Total du mois', 'Total Año': 'Total annuel',
  'Gasto Mes': 'Dépense du mois', 'Órdenes': 'Commandes', 'Orden': 'Commande',
  'Nueva Orden': 'Nouvelle commande', 'Nuevo Proveedor': 'Nouveau fournisseur',
  'Nueva Factura': 'Nouvelle facture', 'Agregar Factura': 'Ajouter facture',
  'Nuevo Cliente': 'Nouveau client', 'Nueva Cita': 'Nouveau rendez-vous',
  'Nueva Tarea': 'Nouvelle tâche', 'Cita': 'Rendez-vous',
  'Citas': 'Rendez-vous', 'Tarea': 'Tâche', 'Tareas': 'Tâches',
  'Recordatorio': 'Rappel', 'Prioridad': 'Priorité',
  'Alta': 'Haute', 'Media': 'Moyenne', 'Baja': 'Basse',
  'Vencido': 'En retard', 'Programado': 'Programmé', 'Terminado': 'Terminé',
  'Propiedad': 'Bien', 'Propiedades': 'Biens', 'Inmueble': 'Bien',
  'Inmuebles': 'Biens', 'Renta': 'Location', 'Alquiler': 'Location',
  'Venta': 'Vente', 'Habitaciones': 'Chambres', 'Baños': 'Salles de bain',
  'Casa': 'Maison', 'Apartamento': 'Appartement',
  'Local': 'Boutique', 'Oficina': 'Bureau', 'Terreno': 'Terrain',
  'No hay datos': 'Aucune donnée', 'No hay resultados': 'Aucun résultat',
  'No hay clientes': 'Aucun client', 'No hay productos': 'Aucun produit',
  'Cargando...': 'Chargement...', 'Cargando': 'Chargement',
  'Procesando...': 'Traitement...', 'Guardando...': 'Enregistrement...',
  'Cliente VIP': 'Client VIP', 'Cliente Frecuente': 'Client fréquent',
  'Cliente Nuevo': 'Nouveau client', 'Cliente Inactivo': 'Client inactif',
  'Reloj Checador': 'Pointeuse', 'Asistencia': 'Présence',
  'Nómina': 'Paie', 'Categorías': 'Catégories', 'Estadísticas': 'Statistiques',
  'Configuración': 'Paramètres', 'Ajustes': 'Paramètres', 'Perfil': 'Profil',
  'Cerrar Sesión': 'Déconnexion', 'Iniciar Sesión': 'Connexion',
  'Crear Cuenta': "Créer un compte", 'Reservar': 'Réserver',
  'Solicitar': 'Demander', 'Enviar': 'Envoyer', 'Recibir': 'Recevoir',
  'Aprobar': 'Approuver', 'Rechazar': 'Rejeter', 'Pagar': 'Payer',
  'Cobrar': 'Encaisser', 'Vender': 'Vendre', 'Comprar': 'Acheter',
  'Entrada': 'Entrée', 'Salida': 'Sortie',
};

// Helper: Try whole-string match first, then per-word (only for short strings).
export function autoTranslate(text, targetLang) {
  if (!text || typeof text !== 'string') return text;
  let dict;
  if (targetLang === 'en') dict = ES_TO_EN;
  else if (targetLang === 'pt') dict = ES_TO_PT;
  else if (targetLang === 'fr') dict = ES_TO_FR;
  else return text;

  // Exact match (case-sensitive) — most precise
  if (Object.prototype.hasOwnProperty.call(dict, text)) {
    return dict[text];
  }

  // Trimmed match
  const trimmed = text.trim();
  if (trimmed !== text && Object.prototype.hasOwnProperty.call(dict, trimmed)) {
    const lead = text.match(/^\s*/)?.[0] || '';
    const trail = text.match(/\s*$/)?.[0] || '';
    return lead + dict[trimmed] + trail;
  }

  // Match ignoring trailing punctuation (: . , ! ? ;)
  const trailMatch = trimmed.match(/^(.+?)([:.,!?;…]+)$/);
  if (trailMatch) {
    const core = trailMatch[1];
    const punct = trailMatch[2];
    if (Object.prototype.hasOwnProperty.call(dict, core)) {
      const lead = text.match(/^\s*/)?.[0] || '';
      const trail = text.match(/\s*$/)?.[0] || '';
      return lead + dict[core] + punct + trail;
    }
  }

  // Match ignoring leading bullets/emojis (🎯 ✓ • · — etc.)
  const leadMatch = trimmed.match(/^([🎯✓✔️•·—▪◆◇►▶︎ⓘ📌🔥⚡️🚀💡⚠️ℹ️*\-\s]+)(.+)$/u);
  if (leadMatch) {
    const prefix = leadMatch[1];
    const core = leadMatch[2];
    if (Object.prototype.hasOwnProperty.call(dict, core)) {
      const lead = text.match(/^\s*/)?.[0] || '';
      const trail = text.match(/\s*$/)?.[0] || '';
      return lead + prefix + dict[core] + trail;
    }
  }

  // Pattern match: "<Word> (NN)" e.g. "Clientes (8)" — translate just the word
  const parenMatch = trimmed.match(/^(.+?)\s*\((\d+(?:\.\d+)?(?:%|\$|h)?)\)$/);
  if (parenMatch) {
    const core = parenMatch[1].trim();
    const num = parenMatch[2];
    if (Object.prototype.hasOwnProperty.call(dict, core)) {
      const lead = text.match(/^\s*/)?.[0] || '';
      const trail = text.match(/\s*$/)?.[0] || '';
      return lead + dict[core] + ' (' + num + ')' + trail;
    }
  }

  return text; // Give up — return original
}
